import React from 'react';
import { ActivityTab, KanbanComment, PendingCommentAttachment, TaskHistoryEntry } from '../types';
import { TaskComments } from './TaskComments';
import { TaskTimeline } from './TaskTimeline';

interface ActivityPanelProps {
  activeTab: ActivityTab;
  onTabChange: (tab: ActivityTab) => void;
  comments: KanbanComment[];
  history: TaskHistoryEntry[];
  newComment: string;
  onNewCommentChange: (value: string) => void;
  onSendComment: () => void;
  onAttachFiles?: (files: FileList) => void;
  pendingAttachments?: PendingCommentAttachment[];
  onRemovePendingAttachment?: (localId: string) => void;
  isCommentSending?: boolean;
  currentUserId?: string | null;
  onDeleteComment?: (commentId: string) => void;
}

export const ActivityPanel: React.FC<ActivityPanelProps> = ({
  activeTab,
  onTabChange,
  comments,
  history,
  newComment,
  onNewCommentChange,
  onSendComment,
  onAttachFiles,
  pendingAttachments = [],
  onRemovePendingAttachment,
  isCommentSending,
  currentUserId,
  onDeleteComment,
}) => (
  <section className="task-details-modal__card task-details-modal__activity-card">
    <div className="task-details-modal__tabs">
      <button
        type="button"
        className={`task-details-modal__tab ${activeTab === 'comments' ? 'task-details-modal__tab--active' : ''}`}
        onClick={() => onTabChange('comments')}
      >
        Comments
      </button>
      <button
        type="button"
        className={`task-details-modal__tab ${activeTab === 'history' ? 'task-details-modal__tab--active' : ''}`}
        onClick={() => onTabChange('history')}
      >
        History
      </button>
    </div>

    {activeTab === 'comments' ? (
      <TaskComments
        comments={comments}
        newComment={newComment}
        onNewCommentChange={onNewCommentChange}
        onSend={onSendComment}
        onAttachFiles={onAttachFiles}
        pendingAttachments={pendingAttachments}
        onRemovePendingAttachment={onRemovePendingAttachment}
        isSending={isCommentSending}
        currentUserId={currentUserId}
        onDeleteComment={onDeleteComment}
      />
    ) : (
      <TaskTimeline items={history} />
    )}
  </section>
);
